import React, { Component } from "react";
import { create } from "jss";
import rtl from "jss-rtl";
import JssProvider from "react-jss/lib/JssProvider";
import {
  MuiThemeProvider,
  createMuiTheme,
  createGenerateClassName,
  jssPreset
} from "@material-ui/core/styles";
//import indigo from '@material-ui/core/colors/indigo';
import red from "@material-ui/core/colors/red";
import { ApolloProvider } from "react-apollo";
import AppContext from "./AppContext";
import client from "./../../utils/apolloClient";
const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const generateClassName = createGenerateClassName();

class AppProvider extends Component {
  state = {
    type: "light",
    direction: "ltr"
  };

  render() {
    const { direction, type } = this.state;
    const theme = createMuiTheme({
      direction,
      palette: {
        type,
        primary: {
          main: "#1a5c9a"
        },
        secondary: {
          light: "#d4d700",
          main: "#d4d700",
          // dark: will be calculated from palette.secondary.main,
          contrastText: "rgb(0, 50, 162)"
        },
        error: red
      },
      typography: {
        fontFamily: 'Roboto,"Helvetica Neue",Arial,sans-serif',
        headline: {
          fontSize: "1rem"
        },
        subheading: {
          fontSize: "0.8125rem"
        },
        button: {
          fontWeight: 400,
          textTransform: "initial"
        }
      },
      shape: {
        borderRadius: 4
      },
      overrides: {
        MuiAppBar: {
          colorPrimary: {
            backgroundColor: "#d4d700",
            color: "#000"
          }
        }
      }
    });

    return (
      <ApolloProvider client={client}>
        <JssProvider jss={jss} generateClassName={generateClassName}>
          <MuiThemeProvider theme={theme}>
            <AppContext.Provider
              value={{
                state: this.state,
                toggleTheme: () =>
                  this.setState({
                    type: this.state.type === "light" ? "dark" : "light"
                  }),
                toggleDirection: () =>
                  this.setState(
                    {
                      direction: this.state.direction === "ltr" ? "rtl" : "ltr"
                    },
                    () => (document.body.dir = this.state.direction)
                  )
              }}
            >
              {this.props.children}
            </AppContext.Provider>
          </MuiThemeProvider>
        </JssProvider>
      </ApolloProvider>
    );
  }
}

export default AppProvider;
